/* Stop two third-party scripts that this shop pays for and gets nothing back from.
 *
 * Both are injected by apps, neither can be removed with the Admin API we hold, and both are
 * fetched into the MAIN frame — checked, because a Shopify web pixel running in its sandbox would
 * be out of reach from here and this file would be quietly doing nothing.
 *
 * ---------------------------------------------------------------------------------------------
 * 1. KIWI SIZE CHART, on pages with no size chart.  526 KB, 73-82ms of main thread, ZERO DOM
 *    nodes rendered on home, collection and cart. It is not redundant on a product page — it draws
 *    "Check Size Chart" and "What's my size?" — so the gate is the presence of `.auk-kiwi`, the
 *    wrapper the product sections put round its app block. If a template drops the block the
 *    wrapper goes with it and Kiwi correctly stops loading there too.
 *
 *    Kiwi, Loox, GoAffPro and Printful's customiser are legacy ScriptTags: not app embeds, not in
 *    settings_data.json, and `script_tags.json` returns only the calling app's own tags. Shopify
 *    injects a loader into content_for_header that appends all four on `window.load`.
 *
 * NOT HANDLED HERE: the Google tag container GT-PH39SF4T. It is 400 KB parsed on every page and
 * transmits nothing at all — measured by loading each container alone on a blank page and firing
 * page_view, view_item, add_to_cart and purchase: GT-TB7TP9GT made 11 outbound requests,
 * GT-PH39SF4T made 0, including on purchase. It was tried here and REMOVED AGAIN, because the
 * block only landed on some page loads: gtag assigns the container src with `setAttribute`, and
 * pulls the second container from inside its own bundle, so a `src` property-setter patch catches
 * it intermittently. An intermittent block is worse than none — it makes the page behave
 * differently run to run and hides the real problem. It has to be disconnected in
 * Shopify admin -> Google & YouTube -> settings, which is the layer that put it there.
 *
 * ---------------------------------------------------------------------------------------------
 * Why patch document.createElement rather than remove a tag: neither script is referenced by the
 * theme, so there is nothing to remove. Both are created by other people's JavaScript, and the one
 * moment we can intervene is when a src is assigned. The patch is narrow — script elements only,
 * two URL fragments only, everything else set through untouched — and it stays in place rather
 * than unpatching after load, because the pixel runtime injects gtag on its own schedule and an
 * unpatch timed to `load` was a race this does not need to run.
 *
 * To undo: delete the <script> tag for this file from layout/theme.liquid.
 */
(function () {
  'use strict';

  // `needs` is a selector that must be ABSENT for the block to apply; null means always block.
  var BLOCK = [
    { match: 'kiwisizing.com', needs: '.auk-kiwi', label: 'Kiwi Size Chart' }
  ];

  function active() {
    return BLOCK.filter(function (b) { return !b.needs || !document.querySelector(b.needs); });
  }

  // Evaluated once the DOM exists, because `.auk-kiwi` cannot be looked for before then. This file
  // is loaded with `defer`, so by the time it runs the document is parsed.
  var wanted = active();
  if (!wanted.length) return;

  var create = document.createElement;
  var stopped = [];

  document.createElement = function (tag) {
    var el = create.apply(document, arguments);
    if (String(tag).toLowerCase() !== 'script') return el;
    Object.defineProperty(el, 'src', {
      configurable: true,
      get: function () { return this.getAttribute('src') || ''; },
      set: function (v) {
        var hit = wanted.filter(function (b) { return String(v).indexOf(b.match) !== -1; })[0];
        if (hit) {
          if (stopped.indexOf(hit.label) === -1) {
            stopped.push(hit.label);
            if (window.console && console.debug) {
              console.debug('[auk] not loaded on this page: ' + hit.label);
            }
          }
          return;                                  // never gets a src, so never fetches
        }
        this.setAttribute('src', v);
      }
    });
    return el;
  };
})();
